import React, { createContext, useState, useEffect } from 'react';
import {fetchData } from '../api/apiClient';
import { ENDPOINTS } from '../utils/constants';

const StaticDataContext = createContext();

// Flags
// TO DO: FIx
// Known issue, when true, dropdowns do not populate on first load on some users.
// Browser fix is deleting session_storage and local_storage for the statis data
const USE_CACHE = false;

export const StaticDataProvider = ({ children, endpoints = ENDPOINTS }) => {
    const [staticData, setStaticData] = useState(() => {
        if (USE_CACHE) {
            // Load cached data from localStorage on initialization
            const cachedData = localStorage.getItem('staticData');
            return cachedData ? JSON.parse(cachedData) : {};
        }
        return {};
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {
        const fetchAllData = async () => {
            try {
                if (USE_CACHE) {
                    const cachedData = localStorage.getItem('staticData');
                    if (cachedData) {
                        // Use cached data if available
                        setStaticData(JSON.parse(cachedData));
                        setLoading(false);
                        return;
                    }
                }

                // Fetch data from the API if no cache is available or caching is disabled
                const results = await Promise.allSettled(
                    Object.entries(endpoints).map(async ([key, endpoint]) => {
                        const response = await fetchData(endpoint);
                        return [key, response];
                    })
                );

                const successfulResults = results
                    .filter((result) => result.status === 'fulfilled')
                    .map((result) => result.value);

                const fetchedData = Object.fromEntries(successfulResults);
                setStaticData(fetchedData);

                if (USE_CACHE) {
                    // Cache the fetched data in localStorage
                    localStorage.setItem('staticData', JSON.stringify(fetchedData));
                }
            } catch (err) {
                console.error('Unexpected error during data fetching:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchAllData();
    }, []);

    return (
        <StaticDataContext.Provider value={{ staticData, loading, error }}>
            {children}
        </StaticDataContext.Provider>
    );
};

export default StaticDataContext;